import { defineStore } from 'pinia'
import Axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const SITUACOES_URL = BASE_URL + "api/demandasrepetitivas/situacaopuil"
export const usePuilSituacaoStore = defineStore('puilSituacao', {
  state: () => ({ filtered: [], situacoes: [] }),
  getters: {
    all: state => state.situacoes,
  },
  actions: {
    async fetch() {
      const { data } = await Axios.get(SITUACOES_URL)
      const { listaDeSituacoesPuil } = data
      this.filtered = this.situacoes = listaDeSituacoesPuil
      return listaDeSituacoesPuil
    },
  },
})
